/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindContactsByCreatedByIdQueryResponse,
  FindContactsByCreatedByIdPathParams,
} from "../types/FindContactsByCreatedById.ts"

export const findContactsByCreatedByIdQueryKey = (
  createdById: FindContactsByCreatedByIdPathParams["createdById"]
) =>
  [
    {
      url: "/v1/contacts/find-contacts-by-created-by-id/:createdById",
      params: { createdById },
    },
  ] as const

export type FindContactsByCreatedByIdQueryKey = ReturnType<
  typeof findContactsByCreatedByIdQueryKey
>

/**
 * @description Returns all contacts created by the organization identified by createdById (organization UUID).
 * @summary Find contacts by created-by organization id
 * {@link /v1/contacts/find-contacts-by-created-by-id/:createdById}
 */
export async function findContactsByCreatedById(
  createdById: FindContactsByCreatedByIdPathParams["createdById"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindContactsByCreatedByIdQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/contacts/find-contacts-by-created-by-id/${createdById}`,
    ...requestConfig,
  })
  return res
}

export function findContactsByCreatedByIdQueryOptions(
  createdById: FindContactsByCreatedByIdPathParams["createdById"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findContactsByCreatedByIdQueryKey(createdById)
  return queryOptions<
    ResponseConfig<FindContactsByCreatedByIdQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindContactsByCreatedByIdQueryResponse>,
    typeof queryKey
  >({
    enabled: !!createdById,
    queryKey,
    queryFn: async ({ signal }) => {
      return findContactsByCreatedById(createdById, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @description Returns all contacts created by the organization identified by createdById (organization UUID).
 * @summary Find contacts by created-by organization id
 * {@link /v1/contacts/find-contacts-by-created-by-id/:createdById}
 */
export function useFindContactsByCreatedById<
  TData = ResponseConfig<FindContactsByCreatedByIdQueryResponse>,
  TQueryData = ResponseConfig<FindContactsByCreatedByIdQueryResponse>,
  TQueryKey extends QueryKey = FindContactsByCreatedByIdQueryKey,
>(
  createdById: FindContactsByCreatedByIdPathParams["createdById"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindContactsByCreatedByIdQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findContactsByCreatedByIdQueryKey(createdById)

  const query = useQuery(
    {
      ...findContactsByCreatedByIdQueryOptions(createdById, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
